import React from 'react';
import PropTypes from 'prop-types';
import SearchListItem from '../SearchList/item';
import { injectIntl } from 'react-intl';
import messages from './messages';
import SaveBookmarkButton from '../SaveBookmarkButton';

const BookmarkRecommendation = props => (
  <SearchListItem
    key={`item-${props.item.id}`}
    title={props.item.title}
    subtitle={props.intl.formatMessage(messages[props.item.description])}
    backgroundImage={props.item.image}
    link={props.item.url}
  >
    <SaveBookmarkButton
      title={props.item.title}
      image={props.item.image}
      status="create"
      url={props.item.url}
      type={props.item.description}
    />
  </SearchListItem>
);

BookmarkRecommendation.propTypes = {
  item: PropTypes.shape({
    id: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
    ]),
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    image: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
  }).isRequired,
};

export default injectIntl(BookmarkRecommendation);
